//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// FIXME: dp-modal breaks layout when sharing dp-container with multiple tables
// (https://github.com/DevicePilot/devicepilot/issues/434)
import DpButton from '../button/Button.vue';
import DpControlGroup from '../layout/ControlGroup.vue';

export default {
  name: 'DpModal',
  components: {
    DpButton,
    DpControlGroup,
  },
  props: {
    visible: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    title: { type: String, default: '' },
    maxWidth: { type: String, default: null },
  },
  data() {
    return {
      shown: false,
      appRoot: null,
    };
  },
  computed: {
    hasButtons() {
      return this.$slots.buttons && this.$slots.buttons.length > 0;
    },
  },
  mounted() {
    this.appRoot = document.querySelector('#app-root') || document.querySelector('#docs-root');
    if (this.appRoot) {
      this.appRoot.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    if (this.appRoot && this.$el.parentNode === this.appRoot) {
      this.appRoot.removeChild(this.$el);
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.$emit('update:visible', false);
    },
  },
};
